import PropTypes from "prop-types";

import { Button } from "@mui/material";

import styles from "./Welcome.module.scss";

const Welcome = ({ handleOptOut, currentJob, submission, varinerContact, handleOptIn }) => {
  return (
    <div className={styles.wapper}>
      <h1 className={styles.title}>
        {`${currentJob?.clientCorporation?.name} - ${currentJob?.publicName}`}
      </h1>

      <h3 className={styles.subtitle}>
        Hi, {`${submission?.candidate?.firstName}`}. We appreciate your time and potential interest
        in the {currentJob?.publicName} role at {currentJob?.clientCorporation?.name}. Please select
        an option below to either continue in the process or pass on this opportunity.
      </h3>

      <p className={styles.link}>
        Not {`${submission?.candidate?.firstName} ${submission?.candidate?.lastName}`}? Please
        contact
        <a href={`mailto:${varinerContact.email}`} /* underline="hover" */>{varinerContact.name}</a>
        for more information.
      </p>

      <div className={styles["button-container"]}>
        <Button variant="contained" color="primary" size="medium" onClick={handleOptIn}>
          Opt In
        </Button>

        <Button variant="default" color="secondary" size="medium" onClick={handleOptOut}>
          Not Interested
        </Button>
      </div>
    </div>
  );
};

Welcome.propTypes = {
  currentJob: PropTypes.any,
  submission: PropTypes.any,
  varinerContact: PropTypes.any,
  handleOptIn: PropTypes.func,
  handleOptOut: PropTypes.func
};

export { Welcome };
